<template>
    <div v-if="product.supplyEnabled" :class="{'product-intro__table-row-group': !sidebar, 'product-sidebar__option-row-group': sidebar}">
        <div v-for="(group, index) in groups" :key="index" :class="{'product-intro__table-row': !sidebar, 'product-sidebar__option-row': sidebar}">
            <div :class="{'product-intro__table-th': !sidebar, 'product-sidebar__option-th': sidebar}">
                <span v-if="index == 0" class="th">추가상품</span>
            </div>
            <div :class="{'product-intro__table-td': !sidebar, 'product-sidebar__option-td': sidebar}">
                <select v-model="selected[index]" class="product-intro__select" name="" @change="input(selected[index])">
                    <option :value="undefined" disabled selected>{{ `:: ${group.name} 옵션을 선택하세요 ::` }}</option>
                    <option v-for="(supply, key) in group.supplies" :key="key" :value="supply" :disabled="supply.stock == 0">
                        {{ supply.group.value }}
                        <span>{{ getPrice(supply) }}</span>
                        <span v-if="!supply.stock"> (품절)</span>
                    </option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: { type: Array, default: null }, // product
        product: { type: Object, default: null },
        sidebar: { type: Boolean, default: false }
    },
    data() {
        return {
            supplies: this.$props.product.supplies,
            selected: []
        };
    },
    methods: {
        input(supply){
            
            // 이미 답겨있는경우 스킵
            if(this.value.find(pickup => pickup._supply == supply._id)) return;

            this.$set(this.value, this.value.length, {
                ...supply,
                _supply: supply._id,
                quantity: 1,
            });

            this.$emit('input', this.value);
        },
        getPrice(supply){
            var price = this.scope.includes("company") ? parseInt(+supply.companyPrice || 0) : parseInt(+supply.price || 0);
            return 0 <= price ? ` (+${price.format()}원)` : ` (${price.format()}원)`;
        }
    },
    computed: {
        groups(){
            return this.supplies.reduce((groups, supply) => {
                // for(var supplyGroup of supply.groups){
                var group = groups.find(group => group.name == supply.group.name) || { values: [], supplies: [] };
                var { values, supplies } = group;
                
                if(!values.includes(supply.value)){
                    values = values.concat(supply.group.value);
                    supplies = supplies.concat(supply);
                }

                Object.assign(group, {
                    name: supply.group.name,
                    values,
                    supplies
                });

                if(groups.indexOf(group) < 0) groups.push(group);
                // }
                return groups;
            }, []);
        },
        payload(){
            return this.$store.state.payload || {};
        },
        scope(){
            return this.payload.scope || [];
        }
    }
}
</script>
